import { LoginPage } from './LoginPage';

/**
 * Registration lives on the one shared card: the central `<suite-gate>`'s
 * "New to Ortam? Create an account" switch covers it, so this route renders
 * the same gate as /auth/login.
 */
export function RegisterPage() {
  return <LoginPage />;
}
